module.exports = __webpack_public_path__ + "static/media/whole-foods.f80680da.png";